import state from './state.js'
import './observer-local-storage.js'
import './observer-cart.js'

export default state
